import {log, cuppa, val, wait} from "../../../cuppa/cuppa";
import {useEffect, useState} from "react";
import {UserCtrl} from "../../controllers/UserCtrl";
import {Storages} from "../../controllers/Storages";
import {CuppaStorage} from "../../../cuppa/cuppa.storage";
import {Utils} from "../../controllers/Utils";
import SpinnerWhite from '../../media/images/spinner-white.svg';
import {Constants} from "../../controllers/Constants";
import {OrganizationCtrl} from "../../controllers/OrganizationCtrl";
import {Alert} from "../commond/Alert";
import {Language} from "../../controllers/Language";
import packageJson from '../../../../package.json';
import {Globals} from "../../controllers/Globals";
import {Link} from "react-router-dom";
import {Message} from "../commond/Message";
import {InputText, InputTextTypes} from "../commond/fields/InputText";

export function Login(props){
	const [form, setForm] = useState({activationCode:'', email:'', password:''});
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState();

	useEffect(()=>{
		CuppaStorage.getData(Storages.loginFormData).then(setForm);
	}, []);

	async function onSubmit(e){
		e.preventDefault(); e.stopPropagation();
		let validation = cuppa.validateFormObject(form, {activationCode:{required:true}, email:{required:true, type:'email'}, password:{required:true}})
		if(!validation.valid){
			let message = `${cuppa.capitalize(validation.label)} ${validation.message}`;
			Globals.mainPortal.add("Alert", <Alert key={"Alert"} message={message} />)
			return;
		}
		setLoading(true);
		let result = await UserCtrl.auth({...form});
		setLoading(false);
		setError(val(result, `errors.0`));
		if(val(result, `errors.0.message`)){
			if(val(result, `errors.0.message`) === Constants.ACTIVATION_CODE_INVALID){
				Globals.mainPortal.add("Alert", <Alert key={"Alert"} message={'Organization code is invalid.'} />)
				return;
			}else if(val(result, `errors.0.message`) === Constants.USER_DISABLED){
				Globals.mainPortal.add("Alert", <Alert key={"Alert"} message={'Your user has been disabled.'} />)
				return;
			}
		}
		if(!result?.data?.auth?.accessToken){
			Globals.mainPortal.add("Alert", <Alert key={"Alert"} title={Language.value('Login Failed')} message={Language.value('Your email or password is incorrect. Please try again.')} />)
			return;
		}
		//CuppaStorage.setData({...Storages.auth, data:result.data.auth}).then();
		setLoading(true);
		let organization = await OrganizationCtrl.loadOrganization({activationCode:form.activationCode});
		let userId = val(Utils.parseJWT(result?.data.auth?.accessToken), 'data.user_id', null);
		let user = await UserCtrl.loadUser({id:userId, organizationId:organization.id});
		setLoading(false);
		if(!user?.data?.user) return;
		CuppaStorage.setData({...Storages.organization, data:organization}).then();
		CuppaStorage.setData({...Storages.user, data:user.data.user}).then();
		UserCtrl.setLoginFormData(form);
	}

	return (
		<form onSubmit={onSubmit} style={{display:'flex', flexDirection:'column',  padding:30}}>
			<h2>{Language.value('Login Access')}</h2>
			{(error?.extensions?.attempts && error?.extensions?.attempts < error?.extensions?.max) ? (
				<Message className={`bg-warning-light f-14 p-x-10 p-y-10 b-radius-3 m-t-10`}>
					{`${Language.value(`Login failed. Attempts remaining`)}: ${error?.extensions?.max - error?.extensions?.attempts}`}
				</Message>
			) : (error?.message === Constants.USER_DISABLED && error?.extensions?.attempts >= error?.extensions?.max) ? (
				<Message className={`f-14 bg-error-light p-x-20 p-y-20 b-radius-3 m-t-10`} >
					<div dangerouslySetInnerHTML={{__html:Language.value(`accountLockedMessage`)}}></div>
				</Message>
			) : (null)}
			<label htmlFor={"organization"} className="label1" style={{marginTop:20}}>{Language.value('Community')}</label>
			<input id={"organization"} defaultValue={form.activationCode} className="input1" onChange={e=>{setForm({...form, activationCode:e.target.value})}} />
			<label htmlFor={"email"} className="label1" style={{marginTop:10}}>{Language.value('Email')}</label>
			<input id={"email"} defaultValue={form.email} className="input1" onChange={e=>{setForm({...form, email:e.target.value})}} />
			<label htmlFor={"password"} className="label1" style={{marginTop:10}}>{Language.value('Password')}</label>
			<InputText type={InputTextTypes.PASSWORD} value={form.password} callback={value=>setForm({...form, password:value})} showRevealIcon={true} />
			<button className={`button1 m-t-15 ${loading ? 'disabled' : null}`} type={"submit"} >
				{loading &&
					<img src={SpinnerWhite} width={16} height={16} alt={"loading"} style={{marginRight:10}}/>
				}
				<span>{Language.value('Sign In')}</span>
			</button>
			<div className={'flex j-end m-t-10'}>
				<Link to={"/forgot-password"} className={'d-i-children btn-alpha'} >{Language.value('Forgot your password?')}</Link>
			</div>
		</form>
	)
}
